import React from "react";
import { useState, useEffect } from "react";
import { CreateBatch } from "../../services/BatchService";
import { getFormattedDateTime } from "../../services/dateService";
import { NotificationManager } from "react-notifications";
import ScannerInput from "./ScannerInput";
import cloneDeep from "clone-deep";

const model = {
	id: 0,
	analysisType: "",
	inTime: null,
	outTime: null,
	samplesInBatch: [],
	location: "",
	reviewComment: "",
};

export default function MicroIn({ location, user, submitted }) {
	const [samples, setSamples] = useState([]);
	const [instance, setInstance] = useState();
	// const [user, setUser] = useState("");

	useEffect(() => {
		setInstance({ ...instance, location: location });
	}, [location]);

	useEffect(() => {
		let i = cloneDeep(model);
		i.inTime = getFormattedDateTime();
		i.location = location;
		setInstance(i);
	}, []);

	const handleScan = (scan) => {
		if (!samples.find((s) => s === scan))
			setSamples((oldArry) => [...oldArry, scan]);
	};

	const removeScan = (scan) => {
		setSamples(samples.filter((i) => i !== scan));
	};

	const handleSubmit = async () => {
		let submissionModel = instance;
		submissionModel.InUser = user;

		if (!submissionModel.location || submissionModel.location === "") {
			NotificationManager.error("Location is not set", "Error Submitting");
			return;
		}

		samples.map((item) => {
			if (submissionModel.analysisType.indexOf("HPC") === -1) {
				submissionModel.samplesInBatch.push({
					sampleLabId: item,
					ecoli: false,
					coliform: false,
					reviewComment: submissionModel.reviewComment
				});
			} else {
				submissionModel.samplesInBatch.push({ sampleLabId: item, reviewComment: submissionModel.reviewComment });
			}
		});

		try {
			let response = await CreateBatch(submissionModel);

			let i = cloneDeep(model);
			i.inTime = getFormattedDateTime();
			i.location = location;
			setInstance(i);
			setSamples([]);
			submitted();
			NotificationManager.success("Batch created");
		} catch (err) {
			NotificationManager.error(err.toString(), "Error Submitting");
		}
	};

	return (
		<>
			<div className="columns">
				<div className="column">
					<span>
						<label htmlFor="" className="label">
							Analysis Type
						</label>
					</span>
					<span>
						<select
							name=""
							id=""
							className="input"
							value={instance?.analysisType}
							onChange={(e) =>
								setInstance({ ...instance, analysisType: e.target.value })
							}
						>
							<option value="">Select analysis type</option>
							{/* Value to be changed to something like HPCPOOL, other code changes needed in backend code */}
							<option value="HPC">HPC (Pool)</option>
							<option value="TCDW">TC (DW)</option>
							<option value="TCPOOL">TC (Pool)</option>
							<option value="Ecoli">E.coli</option>
							{/* Value to be changed to something like HPCDW, other code changes needed in backend code */}
							<option value="HPCDW">HPC (DW)</option>
						</select>
					</span>
				</div>

				<div className="column">
					<span>
						<label htmlFor="" className="label">
							In Time
						</label>
					</span>
					<span>
						<input
							className="input"
							type="datetime-local"
							value={instance?.inTime}
							onChange={(e) =>
								setInstance({
									...instance,
									inTime: getFormattedDateTime(e.target.value),
								})
							}
						/>
					</span>
				</div>
				<div className="column">
					
				</div>
			</div>
			<div className="columns">

			</div>
			<hr />

			<div className="columns">
				<div className="column"></div>
				<div className="column">
					<input type="text" className="input" maxLength="200" placeholder="Batch Comments"
						value={instance?.reviewComment}
						onChange={(e) =>
							setInstance({ ...instance, reviewComment: e.target.value })
						}
					/>
				</div>
			</div>

			<div className="columns">
				<div className="column">
					<table className="table is-striped is-fullwidth">
						<thead>
							<tr>
								<td className="is-bold">
									New Batch - {samples.length} samples{" "}
								</td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							{samples
								.sort(function compare(a, b) {
									try {
										var aSections = a.split("-");
										var bSections = b.split("-");
										if (aSections?.length > 1) {
											if (aSections[0] > bSections[0]) {
												return 1;
											} else if (aSections[0] == bSections[0]) {
												if (parseInt(aSections[1]) > parseInt(bSections[1]))
													return 1;
												else return -1;
											} else {
												return -1;
											}
										}

										return 1;
									} catch (err) {
										console.log(err);
										return 0;
									}
								})
								.map((item) => (
									<tr key={item}>
										<td>
											<span>{item}</span>
										</td>
										<td className="has-text-right">
											<button
												className="button is-small is-rounded is-danger is-bold"
												onClick={() => removeScan(item)}
											>
												X
											</button>
										</td>
									</tr>
								))}
						</tbody>
					</table>
				</div>
				<div className="column">
					{/* <Scanner onScan={handleScan} /> */}
					<br />
					<label htmlFor="" className="label">
						Scanner Input
					</label>
					<ScannerInput onScanComplete={handleScan} />
				</div>
			</div>
			{/* <hr /> */}
			
			<div className="columns">
				<div className="column has-text-centered">
					<button
						className="button is-primary"
						style={{marginLeft:'110px'}}
						disabled={
							!samples ||
							samples.length === 0 ||
							!instance?.inTime ||
							!instance?.location ||
							!instance?.analysisType
						}
						onClick={handleSubmit}
					>
						Submit
					</button>
				</div>
			</div>
		</>
	);
}
